import type {
	ClientPortfolioDetailToolsResponseDTO,
	ClientPortfolioLifeInsuranceCreateRequestDTO,
	ClientPortfolioLifeInsuranceEditRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { mapInvestmentToolsToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/Mappers/mapInvestmentToolsToRequest";
import { mapInsuredPersonsToRequest } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/InsuredPersons/mapInsuredPersons";
import type { LifeInsuranceFormOutput } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";
import { mapManualValueToRequest } from "web_myplann/Portfolio/PortfolioShared/ManualValue/mapManualValueToRequest";

export const mapLifeInsuranceCreateFormToRequest = (
	data: LifeInsuranceFormOutput,
): ClientPortfolioLifeInsuranceCreateRequestDTO => {
	const { insuredPersons, tools, value, invested, valueDate, ...contract } =
		data;
	return {
		...contract,
		insuredPersons: mapInsuredPersonsToRequest(insuredPersons),
		manualValue: mapManualValueToRequest({ value, invested, valueDate }),
		tools: mapInvestmentToolsToRequest(tools),
	};
};

export const mapLifeInsuranceEditFormToRequest = (
	data: Partial<LifeInsuranceFormOutput>,
	premium: Pick<LifeInsuranceFormOutput, "insurance" | "paymentFrequency">,
	originalTools: ClientPortfolioDetailToolsResponseDTO | null | undefined,
): Partial<ClientPortfolioLifeInsuranceEditRequestDTO> => {
	const { insuredPersons, tools, value, invested, valueDate, ...contract } =
		data;
	const isPremiumChanged = "insurance" in data || "paymentFrequency" in data;

	return {
		...contract,
		...(isPremiumChanged && premium),
		...(insuredPersons && {
			insuredPersons: mapInsuredPersonsToRequest(insuredPersons),
		}),
		...(tools && {
			tools: mapInvestmentToolsToRequest(tools, originalTools),
		}),
	};
};
